import { __awaiter } from "tslib";
export const checkAlwaysLoadRule = (rule) => __awaiter(void 0, void 0, void 0, function* () {
    return true;
});
export const validateAlwaysLoadRule = (rule) => {
    return true;
};
